/*
CIRCLE ANIMATION
let bgImage = document.querySelector(".animated-container");
      //  Now registering thescrollTrigger plugin to gsap
      gsap.registerPlugin(ScrollTrigger);
      // Now we are going to animate

      gsap.fromTo(
        bgImage,
        {
          clipPath: "circle(15% at 50% 50%)",
        },
        {
          clipPath: "circle(100% at 50% 50%)",
          ease: "power2",
          //  We want to do that animation on scroll
          scrollTrigger: {
            trigger: bgImage,
            scrub: 1,
            smooth: 1,
            start: "top center",
            end: "top center-=200%",
          },
        }
      );


      
      NON RESPONSIVE ANIMATED SQUARE
let bgImage = document.querySelector(".animated-container");
      //  Now registering thescrollTrigger plugin to gsap
      gsap.registerPlugin(ScrollTrigger);
      // Now we are going to animate

      gsap.fromTo(
        bgImage,
        {
          clipPath: "inset(75px 450px)",
        },
        {
          clipPath: "inset(0px 0px)",
          ease: "power4",
          //  We want to do that animation on scroll
          scrollTrigger: {
            trigger: bgImage,
            effects: true,
            scrub: 1,
            delay:1,
            smooth: 3,
            start: "top center",
            end: "top center-=100%",
          },
        }
      );



ScrollTrigger.matchMedia({
                "(max-width: 1024px) and (min-width: 768px)": function () {
                    gsap.timeline({ scrollTrigger: { trigger: ".animated-container", scrub: !0, effects:true, delay:1, smooth:3, start: "100px center", end: "bottom center" } }).fromTo(
                        ".scaling-mask",
                        1,
                        { clipPath: "inset(7rem 16rem 12rem 16rem)" },
                        { clipPath: "inset(0rem 0rem 0rem 0rem)", ease: Power1.easeInOut }
                    );
                },
                "(max-width: 767px)": function () {
                    gsap.timeline({ scrollTrigger: { trigger: ".animated-container", scrub: !0, effects:true, delay:1, smooth:3, start: "top bottom", end: "bottom center" } }).fromTo(
                        ".scaling-mask",
                        1,
                        { clipPath: "inset(7rem 9rem 10rem 9rem)" },
                        { clipPath: "inset(0rem 0rem 0rem 0rem)", ease: Power1.easeInOut }
                    );
                },
                "(min-width: 1025px)": function () {
                    gsap.timeline({ scrollTrigger: { trigger: ".animated-container", scrub: !0, effects:true, delay:1, smooth:3, start: "top center", end: "top center-=100%" } }).fromTo(
                        ".scaling-mask",
                        1,
                        { clipPath: "inset(7rem 30rem 7rem 30rem)" },
                        { clipPath: "inset(0rem 0rem 0rem 0rem)", ease: Power1.easeInOut }
                    );
                },
});

*/

let bgImage = document.querySelector(".sl-coll-img");
      //  Now registering thescrollTrigger plugin to gsap
      gsap.registerPlugin(ScrollTrigger);
      // Now we are going to animate

      gsap.fromTo(
        bgImage,
        {
          clipPath: "circle(50% at 50% 50%)",
        },
        {
          clipPath: "circle(100% at 50% 50%)",
          ease: "power2",
          //  We want to do that animation on scroll
          scrollTrigger: {
            trigger: bgImage,
            scrub: 1,
            smooth: 1,
            start: "top center",
            end: "top center-=200%",
          },
        }
      );

/*FADING PRODUCT BACKGROUND */
      $(window).on("scroll", function () {
                c();
            }),
            $(".js-update-bg").length > 0 &&
                gsap.utils.toArray(".js-update-bg").forEach((e, t) => {
                    ScrollTrigger.create({
                        trigger: ".js-update-bg",
                      delay:1,
                      smooth:3, 
                        start: "top 45%",
                        end: "bottom center",
                        onEnter: (t) => $("body").css("background-color", $(e).attr("data-color")),
                        onLeave: (e) => $("body").css("background-color", "#fff"),
                        onEnterBack: (t) => $("body").css("background-color", $(e).attr("data-color")),
                        onLeaveBack: (e) => $("body").css("background-color", "#fff"),
                    });
                });







